/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceAssignmentMode } from './resourceAssignmentMode';
import { ResourceSharableAssignmentPreference } from './resourceSharableAssignmentPreference';
import { ResourceCategory } from './resourceCategory';


export interface ResourceOrgCapabilitySpec { 
    aws_assignment_category?: ResourceCategory;
    aws_assignment_mode?: ResourceAssignmentMode;
    cbc_assignment_category?: ResourceCategory;
    cbc_assignment_mode?: ResourceAssignmentMode;
    cbc_onprem_assignment_mode?: ResourceAssignmentMode;
    cbc_byo_allowed?: boolean;
    cbc_onprem_byo_allowed?: boolean;
    cws_assignment_category?: ResourceCategory;
    cws_assignment_mode?: ResourceAssignmentMode;
    cws_onprem_assignment_mode?: ResourceAssignmentMode;
    cws_byo_allowed?: boolean;
    cws_onprem_byo_allowed?: boolean;
    cws_sharable_assignment?: ResourceSharableAssignmentPreference;
    evs_assignment_category?: ResourceCategory;
    evs_assignment_mode?: ResourceAssignmentMode;
    evs_byo_allowed?: boolean;
    evs_sharable_assignment?: ResourceSharableAssignmentPreference;
    gcp_assignment_category?: ResourceCategory;
    gcp_assignment_mode?: ResourceAssignmentMode;
    gcve_assignment_category?: ResourceCategory;
    gcve_assignment_mode?: ResourceAssignmentMode;
    gcve_byo_allowed?: boolean;
    gcve_sharable_assignment?: ResourceSharableAssignmentPreference;
    vmca_assignment_category?: ResourceCategory;
    vmca_assignment_mode?: ResourceAssignmentMode;
    /**
     * Enable/Disable approval required for gcve assign operation
     */
    gcve_sddc_assignment_approval_required?: boolean;
    /**
     * Enable/ Disable approval required for vmca assign operation
     */
    vmca_sddc_assignment_approval_required?: boolean;
    /**
     * Enable/ Disable approval required for evs assign operation
     */
    evs_sddc_assignment_approval_required?: boolean;
}
export namespace ResourceOrgCapabilitySpec {
}


